import actions from "./uzumActions"
import state from "./uzumState"
import mutations from "./uzumMutation"


export default ({
    actions,
    state,
    mutations,
    namespaced: true,
})